export default {
  inject: ['load'],
  data() {
    return {};
  },
  methods: {
    getPatientTechnicianDrugByIdFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientTechnicianDrugById', id).then(() => {
        if (this.$store.state.patientTechnicianDrugModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientTechnicianDrugModule.patientTechnicianDrug;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientTechnicianDrugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientTechnicianDrugModule.successFlag) {
                this.getPatientTechnicianDrugByIdFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPatientTechnicianDrugFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientTechnicianDrug', id).then(() => {
        if (this.$store.state.patientTechnicianDrugModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientTechnicianDrugModule.allPatientTechnicianDrug;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientTechnicianDrugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientTechnicianDrugModule.successFlag) {
                this.getAllPatientTechnicianDrugFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientTechnicianDrugFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientTechnicianDrug', data).then(() => {
        if (this.$store.state.patientTechnicianDrugModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.getAllPatientTechnicianDrugFunction(this.patientId);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientTechnicianDrugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientTechnicianDrugModule.successFlag) {
                this.addPatientTechnicianDrugFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePatientTechnicianDrugFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deletePatientTechnicianDrug', id).then(() => {
        if (this.$store.state.patientTechnicianDrugModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllPatientTechnicianDrugFunction(this.patientId);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientTechnicianDrugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePatientTechnicianDrugFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientTechnicianDrugModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
